import PropertyShow from "../../components/Property/PropertyShow";
import { Outlet, useParams } from "react-router-dom";

export default function PropertyShowPage() {
  const { propertyId } = useParams();

  return (
    <>
      <PropertyShow propertyId={propertyId} />
      <Outlet />
    </>
  );
}
